/**
 * iframe 承接页内的 REST API 入口：在 datalabHttp 基础上自动携带 guest token。
 */
import { AxiosRequestConfig } from 'axios';

import datalabHttp from '../datalabRequest';
import {
  appendIframeAuthorizationHeader,
} from './applyTokenPayload';
import { createTokenAwareFunction } from './core';
import type { ITokenData } from './types';

/** 将 iframe guest token 与承接页上下文写入 axios 请求配置。 */
const applyIframeTokenToAxiosConfig = (
  tokenData: ITokenData,
  oldConfig: AxiosRequestConfig,
): [AxiosRequestConfig] => {
  const newConfig: AxiosRequestConfig = {
    ...oldConfig,
    noAuth: true,
    headers: appendIframeAuthorizationHeader(
      tokenData.token,
      oldConfig.headers,
    ),
    data: {
      ...oldConfig.data,
      game_code: tokenData.gameCode,
      dashboard_id: tokenData.dashboardId,
      system: undefined,
    },
  };
  return [newConfig];
};

const datalabWithTokenHttpBase = createTokenAwareFunction<
  [AxiosRequestConfig],
  [AxiosRequestConfig],
  unknown
>(datalabHttp, applyIframeTokenToAxiosConfig);

/** iframe 承接页内的 REST 请求入口，自动检查刷新 token 并携带 guest 鉴权。 */
export const datalabWithTokenHttp = <TData = unknown>(
  config: AxiosRequestConfig,
): Promise<TData> => datalabWithTokenHttpBase(config) as Promise<TData>;
